import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {EnquiryForm} from "./EnquiryForm";
import {newStackSx} from '@growcloud-io/dc/util/StackUtils';
import {ajax} from "rxjs/ajax";
import {catchError,map,of} from 'rxjs';

const method = 'POST'

const submitEnquiryData = (setShowForm,body) => {
  let url = `https://beta-gcio-server.growcloud.io/enquiry`;

  return ajax({url,body,method})
    .pipe(
      map(data => data.response),
      catchError(error => {
        console.error('Error occurred:',error);
        return of({error:true,message:error.message});
      }))
    .subscribe({
      next:data => {
        console.log('Success:',data);
        setShowForm(false);
      },
      error:err => {
        setShowForm(false);
      }
    });
}

export const EnquiryPage = ({}) => {

  const [showForm,setShowForm] = React.useState(true);

  return (
    <>
      <Stack direction="column" sx={newStackSx('center','center')}>
        <Typography
          variant="h3"
        >BETA PROGRAM</Typography>

        {showForm ? (
          <>
            <Typography
              variant="h6"
            >APPLY</Typography>

            <EnquiryForm
              onSubmit={(data) => {
                submitEnquiryData(setShowForm,data)
              }}
            />
          </>
        ): (
          <>
            <Typography
              variant="h6"
            >APPLICATION SUBMITTED.</Typography>
          </>
        )}
      </Stack>
    </>
  );
}
